<!--
-->
<template>
<v-card :flat='flat'>
  <request-status :request='statementRequest' :message200='false' />
  <v-card-title
    @click='collapsed=!collapsed'
    class='py-0 pl-0 overline'>
    <v-btn @click.stop='getStatement' :loading='statementRequest.loading' icon small >
      <v-icon small >replay</v-icon>
    </v-btn>
    {{ $tc('appointmentsselected', numAppointments, {count: numAppointments}) }}
    <v-spacer />
    <v-icon v-if='collapsed' >expand_more</v-icon>
    <v-icon v-else >expand_less</v-icon>

    <!-- {{ numAppointments }} appointments selected -->
  </v-card-title>
  <v-list dense three-line class='pa-0' >
    <!-- <template v-if='appointment && appointment.id' >
      <appointment-list-item
        :appointment = 'appointment'
        :with-action = 'false' >
      </appointment-list-item >
    </template> -->
    <template v-if='!collapsed' >
      <template v-for='appointment in statementAppointments' >
        <appointment-list-item with-status-chips
          :key='appointment.id'
          :appointment = 'appointment'
          :with-action = 'false' >

          <!-- <template slot="actions" v-if="withEdit" >
            <v-list-tile-action >
              <v-btn icon flat
                @click="$emit('remove', appointment)"
                class="mr-2" color="error" title="Remove from invoice" ><v-icon>remove_circle</v-icon></v-btn>
            </v-list-tile-action>
            <v-divider vertical class="mr-2" />
          </template> -->

          <template slot="action" >
            <v-list-tile-action v-if="withEdit" >
              <v-btn
                @click="$emit('edit', appointment)"
                icon class="mr-2" ><v-icon>edit</v-icon></v-btn>
            </v-list-tile-action>
            <v-list-tile-action v-if='appointment.financials' class='subheading' >
              <!-- <v-list-tile-action-text
                v-if='appointment.financials.payments_received && parseFloat(appointment.financials.payments_received) > 0' >
                  price: {{ formatCurrency(appointment.currency, appointment.price) }}
              </v-list-tile-action-text >
              <v-list-tile-action-text
                v-if='appointment.financials.payments_received && parseFloat(appointment.financials.payments_received) > 0' >
                  paid: {{ formatCurrency(appointment.currency, appointment.financials.payments_received) }}
              </v-list-tile-action-text > -->
              <span class='mt-3' >
                <!-- <span class='caption grey--text' >due</span> -->
                {{ formatCurrency(appointment.currency, appointment.financials.final_due) }}
              </span>
              <v-list-tile-action-text >Due</v-list-tile-action-text >
            </v-list-tile-action >
          </template>
        </appointment-list-item >
        <v-divider :key='`div-${appointment.id}`' />
      </template>
    </template>
    <template v-if='withTotals && totalDue !== null' >
      <v-divider />
      <v-subheader class='overline py-0 py-0' >Totals</v-subheader>
      <v-list-tile class='pb-5' >
        <slot name='list-tile' v-if='totalDue > 0' >
        </slot>
        <v-spacer />
        <v-list-tile-action class='subheading' >
          <v-list-tile-action-text
            v-if='appointmentPrice && parseFloat(appointmentPrice) > 0' >
              appointments: {{ formatCurrency(currency, appointmentPrice) }}
          </v-list-tile-action-text >
          <v-list-tile-action-text
            v-if='discounts && parseFloat(discounts) > 0' >
              product sales: {{ formatCurrency(currency, productSales) }}
          </v-list-tile-action-text >

          <!-- payments -->
          <v-list-tile-action-text
            v-if='discounts && parseFloat(discounts) > 0' >
              discounts: {{ formatCurrency(currency, discounts) }}
          </v-list-tile-action-text >
          <v-list-tile-action-text
            v-if='totalPaid && parseFloat(totalPaid) > 0' >
              payments: {{ formatCurrency(currency, totalPaid) }}
          </v-list-tile-action-text >
          <span class='mt-1' >{{ formatCurrency(currency, totalDue) }}</span>
          <v-list-tile-action-text >outstanding</v-list-tile-action-text >
        </v-list-tile-action >
      </v-list-tile>
      <slot name='list-end' ></slot>
    </template>
  </v-list>

</v-card>
</template>
<script>
import AppointmentListItem from '@/components/appointment/AppointmentListItem'
import StatementMixin from '@/mixins/statement.js'

export default {
  name: 'ReadOnlyStatementList',
  mixins: [StatementMixin],
  components: {
    AppointmentListItem
  },
  props: {
    value: { type: Object, required: false },
    appointmentIds: { type: Array, default: () => { return [] } },
    due: { type: Number },
    withTotals: { type: Boolean, default: true },
    withEdit: { type: Boolean, default: false },
    initiallyCollapsed: { type: Boolean, default: false },
    debounce: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      editInvoiceDialog: false,
      paidInFull: false,
      collapsed: false,
      selectedAppointment: null
    }
  },
  mounted () {
    this.collapsed = this.initiallyCollapsed
  },
  watch: {
    appointmentIds: {
      immediate: true,
      handler () {
        if (this.debounce) {
          this.debouncedGetStatement()
        } else {
          this.getStatement()
        }
      }
    },
    touch () {
      this.getStatement()
    },
    totalDue: {
      immediate: true,
      handler () {
        this.$emit('update:due', this.totalDue)
      }
    },
    currency: {
      immediate: true,
      handler () {
        this.$emit('update:currency', this.currency)
      }
    },
    relationships: {
      immediate: true,
      handler () {
        let rels = this.relationships
        if (!Array.isArray(rels)) { rels = [this.relationships] }
        this.$emit('update:relationships', rels)
      }
    },
    paidInFull () {
      this.$emit('paidInFull', this.paidInFull)
    },
    statementRequestStatus () {
      if (this.statementRequestStatus === 200) {
        this.$emit('input', this.statementRequest)
      }
    },
    statementLoading () {
      this.$emit('update:loading', this.statementLoading)
    }
  },
  computed: {
    statementRequestStatus () {
      return this.statementRequest.status
    },
    statementLoading () {
      return this.statementRequest.loading
    },
    grandTotal () {
      return this.getObjectPath(this.statementRequest, 'result.meta.grand_total', null)
    },
    appointmentPrice () {
      return this.getObjectPath(this.statementRequest, 'result.meta.appointment_unit_price', null)
    },
    totalDue () {
      return this.getObjectPath(this.statementRequest, 'result.meta.outstanding', null)
    },
    productSales () {
      return this.getObjectPath(this.statementRequest, 'result.meta.products_total_price', null)
    },
    discounts () {
      return this.getObjectPath(this.statementRequest, 'result.meta.discounts', null)
    },
    totalPaid () {
      return this.getObjectPath(this.statementRequest, 'result.meta.payments_received', null)
    },
    relationships () {
      return this.getObjectPath(this.statementRequest, 'result.relationship', [])
    },
    numAppointments () {
      if (this.appointmentIds) {
        return this.appointmentIds.length
      }
      return 0
    }
  },
  i18n: {
    messages: {
      en: {
        appointmentsselected: '{count} appointment selected|{count} appointments selected'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReadOnlyStatementList.vue?23d28a7e